export enum MatchPanelType {
  GameSelection,
  Payment,
  MatchSettings,
  TeamSelection,
  MatchSummary,
  JoinRequests,
  Withdraw,
}
